/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Payout admin
 * Payout application
 * OpenAPI spec version: 1.0
 */

/**
 * Enum representing supported requisite types.
 *
 *  - TYPE_UNSPECIFIED: Default value. Used when no specific requisite type is specified.
 *  - TYPE_CARD: Represents a bank card requisite.
 *  - TYPE_SBP: Represents a SBP (System of Fast Payments) requisite.
 *  - TYPE_CRYPTO: Represents a cryptocurrency requisite.
 */
export enum UniteTypeRequisiteType {
    TYPE_UNSPECIFIED = 'TYPE_UNSPECIFIED',
    TYPE_CARD = 'TYPE_CARD',
    TYPE_SBP = 'TYPE_SBP',
    TYPE_CRYPTO = 'TYPE_CRYPTO',
}
